<template>
  <div class="detailCont_warp">
    <div class="active_title"></div>
    <div class="head_cont">
      <div class="img">
        <img v-if="contentData.image" :src="contentData.image" alt="" />
        <!-- <img v-else src="@/assets/active/img.png" alt="" /> -->
      </div>
      <div class="right_cont">
        <div class="cont_info">
          <p class="title">{{ contentData.title }}</p>
          <p class="info">{{ contentData.desc }}</p>
          <p class="tips flex">
            <img src="@/assets/active/icon2.png" alt="" />
            <span>活动形式：{{ contentData.way == 1 ? "线上" : "线下" }}</span>
          </p>
          <p class="btn" @click="orderState=true">立即报名</p>
        </div>
      </div>
    </div>
    <div class="nav_box">
      <div class="left_cont_info">
        <p class="text">活动内容</p>
        <div v-html="contentData.content"></div>
      </div>
      <div class="right_active_list" v-if="recommedList.length>0">
        <div class="tips_cont flex">
          <p class="text">活动推荐</p>
          <p class="img" @click="$router.push('/activityList')">
            <span>更多</span>
            <img src="@/assets/active/right.png" alt="" />
          </p>
        </div>
        <div class="list">
          <ul>
            <li v-for="item in recommedList" :key="item.id" @click="getDetail(item.id)">
              <p class="img">
                <img v-if="item.image" :src="item.image" alt="" />
                <img v-else src="@/assets/active/img.png" alt="" />
              </p>
              <!-- <p class="text">
                {{item.title}}
              </p> -->
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 预约登记 -->
    <div class="mask_main flex" v-if="orderState">
      <div class="show_box">
        <div class="title flex">
          <p class="tips">报名</p>
          <p class="close cursor" @click="orderState = false">
            <img src="@/assets/active/close_ico.png" alt="" />
          </p>
        </div>
        <div class="form_box">
          <ul>
            <li>
              <p class="label">手机号</p>
              <p class="input">
                <input
                  type="num"
                  v-model="yuyForm.phone"
                  placeholder="请输入手机号"
                  maxlength="11"
                />
              </p>
            </li>
            <li>
              <p class="label">姓名</p>
              <p class="input">
                <input
                  type="num"
                  v-model="yuyForm.name"
                  placeholder="请输入姓名"
                />
              </p>
            </li>
            <li>
              <p class="label">备注</p>
              <p class="input">
                <textarea
                  v-model="yuyForm.remark"
                  name=""
                  id=""
                  cols="30"
                  rows="10"
                  placeholder="请填写备注...."
                ></textarea>
              </p>
            </li>
          </ul>
          <p
            v-if=" yuyForm.phone"
            class="btns bgm cursor"
            @click="submitBtn"
          >
            提交报名信息
          </p>
          <p v-else class="btns cursor">提交报名信息</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { activityDetail ,activityRecommend,activityForm} from "@/API/api";

export default {
  name: "active_box",
  data() {
    return {
      detailId: "",
      contentData: {},
      orderState: false, // 预约
      yuyForm: {
        activity_id:'',
        source:'ksk开放平台',
        name: "",
        phone: "",
        remark: "",
      },
      recommedList:[]
    };
  },
  created(){
this.contentData ={}
  },
  mounted() {
    
     document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.detailId = this.$route.query.id;
    if (this.detailId) {
      this.getDetail(this.detailId);
    }
    this.getList()
  },
  methods: {
    getDetail(id) {
      activityDetail({ id: id}).then((res) => {
        console.log(res, "ppp");

        res.data.content = res.data.content.replace(
          /\<img/gi,
          '<img style="max-width:100%;height:auto;"'
        );
        this.contentData = res.data;
      });
    },
    getList(){
      activityRecommend().then(res=>{
        console.log(res)
        this.recommedList = res.data
      })
    },

    submitBtn(){
      this.yuyForm.activity_id = this.detailId
    if(!this.isMobile(this.yuyForm.phone)){
           this.$message.error('请填写正确的手机号')
              return;
      }
      activityForm(this.yuyForm).then(res=>{
         if(res.code==1){
          this.$message.success(res.msg)
         }else{
          this.$message.error(res.msg)
         }
         this.orderState = false
      })
    },
    isMobile(value) {
			return /^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(value);                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      return /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(value);
		},
  },
};
</script>
<style scoped lang="less">
.detailCont_warp {
  width: 1090px;
  margin: 108px auto 0;
  div.active_title {
    font-size: 15px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    height: 1px;
  }
  .head_cont {
    margin-top: 82px;
    position: relative;
    margin-bottom: 38px;
    div.img {
      position: absolute;
      left: 0;
      bottom: 27px;
      width: 450px;
      height: 255px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 5px;
      }
    }
    .right_cont {
      margin-left: 54px;
      width: 1036px;
      min-height: 228px;
      padding-bottom: 15px;
      background: #ffffff;
      box-shadow: 0px 2px 11px 1px rgba(20, 53, 193, 0.16);
      border-radius: 0px 0px 0px 0px;
      .cont_info {
        margin-left: 440px;
        p.title {
          padding-top: 28px;
          margin-right: 46px;
          font-size: 27px;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          color: #333333;
        }
        p.info{
          font-size: 14px;
          color: #666;
          margin-top: 10px;
        }
        p.tips {
          margin-top: 18px;
          img {
            width: 23px;
            height: 23px;
          }
          span {
            font-size: 14px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #999999;
          }
        }
        p.btn {
          margin-top: 16px;
          width: 189px;
          height: 46px;
          background: linear-gradient(270deg, #ff9211 0%, #ff6711 100%);
          border-radius: 8px 8px 8px 8px;
          text-align: center;
          line-height: 46px;
          color: #fff;
          font-size: 18px;
          cursor: pointer;
        }
      }
    }
  }
  .nav_box {
    display: flex;
    margin-bottom: 92px;
    margin-top: 100px;
    .left_cont_info {
      width: 693px;
      p.text {
        font-size: 26px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        margin-bottom: 21px;
        font-weight: bold;
      }
      div {
        img {
          max-width: 100%;
        }
      }
    }
    .right_active_list {
      width: 371px;
      margin-left: 27px;

      .tips_cont {
        padding: 0 30px;
        justify-content: space-between;
        margin-bottom: 21px;
        p.text {
          font-size: 26px;
          color: #666666;
          font-weight: bold;
        }
        p.img {
          cursor: pointer;
          span {
            font-size: 12px;
            color: #999999;
          }
          img {
            width: 12px;
            height: 12px;
          }
        }
      }
      div.list {
        overflow: hidden;
        padding: 30px;
        img {
          width: 100%;
          border-radius: 10px;
          box-shadow: 0px 2px 8px 1px rgba(20, 53, 193, 0.16);
          overflow: hidden;
          margin-bottom: 18px;
        }
        // ul {
        //   margin: 31px;
        //   li {
        //     cursor: pointer;
        //     display: flex;
        //     align-items: center;
        //     margin-bottom: 18px;
        //     p.img {
        //       width: 100%;
        //       box-shadow: 0px 2px 8px 1px rgba(20, 53, 193, 0.16);
              
        //     }
        //     p.text {
        //       flex: 1;
        //       margin-left: 9px;
        //       font-size: 12px;
        //       color: #333333;
        //     }
        //   }
        // }
      }
    }
  }
}
// 预约登记弹框
.mask_main {
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  justify-content: center;
  width: 100%;
  height: 100%;

  .show_box {
    width: 410px;
    // height: 595px;
    background: #ffffff;
    box-shadow: 0px 2px 10px 1px rgba(0, 0, 0, 0.05);
    border-radius: 5px 5px 5px 5px;
    padding: 32px;
    .title {
      justify-content: space-between;
      p.tips {
        font-size: 18px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #333333;
      }
      p.close {
        width: 13px;
        height: 13px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .form_box {
      ul {
        li {
          margin-top: 25px;
          p.label {
            font-size: 14px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #333333;
          }
          p.input {
            margin-top: 16px;
            width: 346px;

            border-radius: 4px 4px 4px 4px;
            opacity: 1;
            border: 1px solid #eeeeee;
            input {
              border: none;
              outline: none;
              margin-left: 16px;
              width: 80%;
              height: 100%;
              font-size: 14px;
              height: 35px;
            }
            textarea {
              width: 346px;
              height: 80px;
              border-radius: 4px 4px 4px 4px;
              opacity: 1;
              resize: none;
              padding: 8px 14px;
              outline: none;
              border: none;
            }
          }
          p.border {
            border: none;
            .el-date-picker {
              width: 346px;
            }
          }
        }
      }
      p.btns {
        margin-top: 30px;
        width: 346px;
        height: 38px;
        background: #99c1f2;
        border-radius: 4px 4px 4px 4px;
        text-align: center;
        line-height: 38px;
        color: #fff;
        font-size: 14px;
      }
      p.btns.bgm {
        background: #0065df;
      }
    }
  }
}
</style>
